export const dbName = "MyDatabase";
export const dbVersion = 3;
export const storeName = "KiratnData";
export const tblMySettings = "KirtanPreSettings";
export const keyboardSettings = "keyboardSettings";
export const VMixButtonApiSetting = "VMixButtonApiSetting";
export const tabGroupsStore = "TabGroups";

const IndexedDBService = {
  db: null,

  initDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, dbVersion);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        // main content data obj
        if (!db.objectStoreNames.contains(storeName)) db.createObjectStore(storeName, { keyPath: "id" });
        if (!db.objectStoreNames.contains(tblMySettings)) db.createObjectStore(tblMySettings, { keyPath: "id" });
        if (!db.objectStoreNames.contains(keyboardSettings)) db.createObjectStore(keyboardSettings, { keyPath: "id" });
        if (!db.objectStoreNames.contains(VMixButtonApiSetting)) db.createObjectStore(VMixButtonApiSetting, { keyPath: "id" });
        if (!db.objectStoreNames.contains(tabGroupsStore)) db.createObjectStore(tabGroupsStore, { keyPath: "id" });
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve();
      };

      request.onerror = (event) => {
        reject("IndexedDB initialization error: ", event.target.error);
      };
    });
  },

  addItem(item, objName) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([objName], "readwrite");
      const store = transaction.objectStore(objName);
      const request = store.add(item);

      request.onsuccess = () => resolve();
      request.onerror = (event) => reject("Error adding item: ", event.target.error);
    });
  },

  getData(key, objName) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([objName], "readonly");
      const store = transaction.objectStore(objName);
      const request = store.get(key);

      request.onsuccess = (event) => {
        if (event.target.result) {
          resolve(event.target.result);
        }
      };

      request.onerror = (event) => {
        reject("Error retrieving data: ", event.target.error);
      };
    });
  },

  getAllData(objName) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([objName], "readonly");
      const store = transaction.objectStore(objName);
      const request = store.openCursor();
      const allData = [];

      request.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          allData.push(cursor.value);
          cursor.continue();
        } else {
          // No more entries
          resolve(allData);
        }
      };

      request.onerror = (event) => {
        reject("Error in fetching all data: ", event.target.error);
      };
    });
  },

  closeDB() {
    if (this.db) {
      this.db.close();
      this.db = null;
    }
  },

  updateItem(item, objName) {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        reject("Database not initialized");
        return;
      }

      const transaction = this.db.transaction([objName], "readwrite");
      const store = transaction.objectStore(objName);
      const request = store.put(item);

      request.onsuccess = () => {
        resolve();
      };

      request.onerror = (event) => {
        reject("Error updating item: ", event.target.error);
      };
    });
  },

  deleteItem(id, objName = storeName) {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        reject("Database not initialized");
        return;
      }

      const transaction = this.db.transaction([objName], "readwrite");
      const store = transaction.objectStore(objName);
      const request = store.delete(id);

      request.onsuccess = () => {
        resolve();
      };

      request.onerror = (event) => {
        reject("Error deleting item: ", event.target.error);
      };
    });
  },

  clearObjectStore() {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        reject("Database not initialized");
        return;
      }

      const transaction = this.db.transaction([storeName], "readwrite");
      const store = transaction.objectStore(storeName);
      const request = store.clear();

      request.onsuccess = () => {
        resolve();
      };

      request.onerror = (event) => {
        console.error("Error clearing object store:", event.target.error);
        reject("Error clearing object store: ", event.target.error);
      };
    });
  },

  // checkDB(dbName, dbVersion, dbObject) {
  //   return new Promise((resolve, reject) => {
  //     // Open the IndexedDB with the provided version
  //     const request = indexedDB.open(dbName, dbVersion);

  //     request.onsuccess = function (event) {
  //       const db = event.target.result;

  //       // Check if the database version matches
  //       if (db.version !== dbVersion) {
  //         console.log(`Database version mismatch. Expected ${dbVersion}, found ${db.version}`);
  //         deleteIndexedDB(dbName);
  //         return resolve(false);
  //       }

  //       // Check if the object stores match
  //       const objectStoreNames = db.objectStoreNames;
  //       const dbObjectStores = Object.keys(dbObject);

  //       let objectStoreMismatch = false;

  //       dbObjectStores.forEach((store) => {
  //         if (!objectStoreNames.contains(store)) {
  //           console.log(`Object store "${store}" missing in the database.`);
  //           objectStoreMismatch = true;
  //         } else {
  //           const transaction = db.transaction(store, "readonly");
  //           const objectStore = transaction.objectStore(store);

  //           // Check if indexes match (optional, adjust based on dbObject)
  //           if (dbObject[store].indexes) {
  //             const expectedIndexes = dbObject[store].indexes;
  //             expectedIndexes.forEach((index) => {
  //               if (!objectStore.indexNames.contains(index)) {
  //                 console.log(`Index "${index}" missing in object store "${store}".`);
  //                 objectStoreMismatch = true;
  //               }
  //             });
  //           }
  //         }
  //       });

  //       // If any mismatch is found, delete the database
  //       if (objectStoreMismatch) {
  //         deleteIndexedDB(dbName);
  //         return resolve(false);
  //       }

  //       console.log("Database version and object store structure match.");
  //       db.close();
  //       resolve(true);
  //     };

  //     request.onerror = function (event) {
  //       console.error("Error opening the database:", event.target.error);
  //       reject(event.target.error);
  //     };

  //     request.onupgradeneeded = function () {
  //       console.log("Database schema is being upgraded. Schema will be checked post-upgrade.");
  //     };
  //   });
  // },
};

export default IndexedDBService;
